let navigate = null;

export function setNavigate(n) {
  navigate = n;
}

export function getNavigate() {
  return navigate;
}
